import React, { useEffect, useRef } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';
import { encyptedData, decryptedData } from './Access';

export default function Model(props) {
  const { scene, animations } = useGLTF(props?.viewerIdURL ? props?.viewerIdURL : "");
  const { actions } = useAnimations(animations, scene);

  useEffect(() => {
    if (actions && actions.length) {
      actions[0].play(); // Play the first animation, you can choose any specific animation
    }
  }, [actions]);

  return <primitive object={scene} {...props} />;
}
